import React from 'react';
import { AppstoreOutlined, UnorderedListOutlined } from '@ant-design/icons';

export default function SettingsViewSwitcher({ viewMode, setViewMode, label }) {
  const items = [
    { value: 'list', label: '列表', icon: <UnorderedListOutlined /> },
    { value: 'grid', label: '缩略图', icon: <AppstoreOutlined /> },
  ];
  return (
    <div aria-label={label} className="flare-skill-view-switcher" role="group">
      {items.map((item) => (
        <button
          aria-label={item.label}
          aria-pressed={viewMode === item.value}
          className="flare-skill-icon-button"
          key={item.value}
          onClick={() => setViewMode(item.value)}
          title={item.label}
          type="button"
        >
          {item.icon}
        </button>
      ))}
    </div>
  );
}
